import { render, staticRenderFns } from "./AdvButton.vue?vue&type=template&id=425a8a11"
import script from "./AdvButton.vue?vue&type=script&lang=js"
export * from "./AdvButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/indsol-advisor/indsol-advisor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425a8a11')) {
      api.createRecord('425a8a11', component.options)
    } else {
      api.reload('425a8a11', component.options)
    }
    module.hot.accept("./AdvButton.vue?vue&type=template&id=425a8a11", function () {
      api.rerender('425a8a11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AdvButton.vue"
export default component.exports